import React, { useEffect, useState } from 'react';
import Meme from './meme'; 
import Result from './result'; 
import Header from "./header"




function App(){
    
    
    const [templates,settemplates] = useState([])
    const [img,setimg] = useState(null)
    const [url,seturl] = useState({
        first:"",
        second:"",
    })
    const [result,setresult] = useState(null)


    useEffect(()=>{
        async function getmeme(){
            const res = await fetch('https://api.imgflip.com/get_memes')
            const data = await res.json()
            const a = data.data.memes
            let box_obj = a.filter(b=>{
                return b.box_count === 2
            })
            settemplates(box_obj)  
        }
        getmeme()
    },[]) 

   
    function handle(event){
        let value = event.target.value;
        let name = event.target.name;
        seturl(prev=>{
            return ({
                ...prev,
                [name]:value
            })
        })
    
    }


  
    
    return (

        <div>
            <Header/>
            <div className='text-center'>
                <div className='row'>
                    <div className='col-lg-6'>
                    {img  && <Meme url={img.url} handle={handle} generate={()=>{
                        fetch(`https://api.imgflip.com/caption_image?template_id=${img.id}&text0=${url.first}&text1=${url.second}&username=htetaungkyaw&password=30221018`)
                        .then(res=>res.json())
                        .then(data=>{
                            return setresult(data)
                        })
                    }}/>}
                    </div>
                    <div className='col-lg-6'>
                        {result && <Result url={result.data.url} save={result.data.url} /> }
                    </div>
                </div>
        





        <div className='row'>
            
        {!img && 
          templates.map(image=>{
            return (
                <div className="col-lg-4 text-center">
                <img key={image.id} id={image.id}  src={image.url} className='img-fluid mt-3' style={{width:"450px",height:"400px"}} onClick={()=>{
                    return setimg(image)
                }}/>
             </div>
            )
        })       
        }
      
        </div>      
  
        </div>
        </div>
       
    )

}


export default App